import { render, staticRenderFns } from "./saticitumkayitlar.vue?vue&type=template&id=3a294c57&"
import script from "./saticitumkayitlar.vue?vue&type=script&lang=js&"
export * from "./saticitumkayitlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports